import Template from '../../component/Template.js';
import { useEffect, useRef } from 'react';
import Api from '../../component/Api';
import PDFModal from '../../component/PDFModal.js';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import { ToastContainer, toast } from 'react-toastify';
import Select from 'react-select';
import 'react-toastify/dist/ReactToastify.css';
import '../../Assets/css/resptable.css';
import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import ViewApplicationModal from '../../component/ExternalCredit/ViewExternalCreditApplication.js';
import useViewApplicationModal from '../../component/ExternalCredit/useViewApplication.js';


export default function SFAExternalCreditApplication() {

    const navigate = useNavigate();
    const isAuth = useAuth();
    if (isAuth === false) navigate("/sfa/");

    const tableRef = useRef(null);

    const [errors, setErrors] = useState({ admyear: '', discipline_id: '' });
    const [admissionYears, setAdmissionYears] = useState([]);
    const [disciplines, setDisciplines] = useState([]);
    const [selectedDiscipline, setSelectedDiscipline] = useState(null);
    const [selectedYear, setSelectedYear] = useState(null);
    const [coursetype, setCoursetype] = useState(null);
    const [students, setStudents] = useState([]);
    const [courseDiciplineNameData, setCourseDiciplineNameData] = useState([]);
    const [collegeDiciplineSchemeID, setCollegeDiciplineSchemeID] = useState([]);
    const [courseDiciplineIDData, setCourseDiciplineIDData] = useState([]);
    const [courseDiciplineTypeData, setCourseDiciplineTypeData] = useState([]);
    const [collegeDiciplineTypeData, setCollegeDiciplineTypeData] = useState([]);
    const [courseDiciplineData, setCourseDiciplineData] = useState([]);

    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [modalAction, setModalAction] = useState(null);
    const [selectedCredit, setSelectedCredit] = useState(null);
    const [creditID, setCreditID] = useState(null);
    const [remarks, setRemarks] = useState('');
    const [actionLoading, setActionLoading] = useState(false);
    // const [showViewModal, setShowViewModal] = useState(false);
    // const [viewData, setViewData] = useState(null);
    // const [viewLoading, setViewLoading] = useState(false);

    // // PDF modal: url is an object URL (blob)
    // const [pdfModal, setPdfModal] = useState({ show: false, url: '', name: '', type: '' });
    // const [pdfLoading, setPdfLoading] = useState(false);
    const [semester_id, setSemester] = useState([]);
    const [reload, setReload] = useState(false);
    const [sortBy, setSortBy] = useState({ column: null, direction: 'asc' }); //sort
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredAndSortedData, setfilteredAndSortedData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [total_count, setTotal] = useState(null);
    const { http } = Api();

    const {
        showViewModal,
        viewData,
        viewLoading,
        pdfLoading,
        pdfModal,
        openViewModal,
        closeViewModal,
        openPdfModal,
        closePdfModal,
    } = useViewApplicationModal(http);

    // Cleanup blob URL when PDF modal closes
    useEffect(() => {
        return () => {
            if (pdfModal.url) URL.revokeObjectURL(pdfModal.url);
        };
    }, [pdfModal.url]);



    const ActionBtn = ({ onClick, title, borderColor, hoverBg, hoverColor, icon, baseColor }) => {
        const base = {
            background: '#fff',
            border: `1.5px solid ${borderColor}`,
            color: baseColor || borderColor,
            borderRadius: '7px',
            width: '31px',
            height: '31px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            transition: 'all 0.15s ease',
            flexShrink: 0,
        };
        return (
            <button
                type="button"
                title={title}
                style={base}
                onMouseEnter={e => {
                    e.currentTarget.style.background = hoverBg || borderColor;
                    e.currentTarget.style.color = hoverColor || '#fff';
                    e.currentTarget.style.transform = 'scale(1.1)';
                }}
                onMouseLeave={e => {
                    e.currentTarget.style.background = '#fff';
                    e.currentTarget.style.color = baseColor || borderColor;
                    e.currentTarget.style.transform = 'scale(1)';
                }}
                onClick={onClick}
            >
                <i className={icon} style={{ fontSize: '15px', pointerEvents: 'none' }}></i>
            </button>
        );
    };



    useEffect(() => {
        const fetchAdmissionYears = async () => {
            try {
                const response = await http.get("/Admin/getActiveAdmissionYear");
                const years = response.data.map((year) => ({
                    id: year.id,
                    value: year.admission_year,
                    label: year.admission_year,
                }));
                setAdmissionYears(years);
            } catch (error) {
                console.error("Error fetching admission years:", error);
            }
        };
        fetchAdmissionYears();
    }, []);


    const handleSemesterChange = (selectedOption) => {
        setSemester(selectedOption);
    };


    useEffect(() => {
        const fetchDisciplines = async () => {
            try {
                if (!selectedYear) return;
                const response = await http.get('/College/getSFADisciplines');
                const formatted = response.data.map(d => ({
                    value: `${d.id}-${d.college_course_type}`,
                    label: `${d.discipline_name}-${d.college_course_type}`,
                    discipline_id: d.id,
                    course_type: d.college_course_type
                }));
                setDisciplines(formatted);
            } catch (error) {
                console.error('Error fetching disciplines:', error);
            }
        };
        fetchDisciplines();
    }, [selectedYear]);

    useEffect(() => {

        const fetchStudents = async () => {
            try {
                setLoading(true);
                const response = await http.post('/College/getSFACreditStudents', {
                    admissionyear: selectedYear || null,
                    // semester_id: semester_id || [],
                    discipline_id: selectedDiscipline,
                });
                setStudents(response.data.students || []);
                setCourseDiciplineNameData(response.data.discipline_name);
                setCourseDiciplineIDData(response.data.discipline_id);
                setCourseDiciplineTypeData(response.data.college_course_type);
                setCollegeDiciplineTypeData(response.data.college_discipline_type);
                setCollegeDiciplineSchemeID(response.data.scheme_id);

            } catch (err) {
                console.error('Error fetching students:', err);
                setStudents([]);
            } finally {
                setLoading(false);
            }
        };
        fetchStudents();
    }, [selectedYear, semester_id, reload]);

    const openActionModal = (student, credit_id, action) => {
        setSelectedCredit(student);
        setCreditID(credit_id);
        setModalAction(action);
        setRemarks('');
        setShowModal(true);
    };

    const closeModal = () => {
        setShowModal(false);
        setSelectedCredit(null);
        setCreditID(null);
        setModalAction(null);
        setRemarks('');
    };

    const handleConfirmAction = async () => {
        if (!selectedCredit || !modalAction) return;

        if (modalAction !== 'approve' && !remarks.trim()) {
            toast.error('Remarks are required to proceed.');
            return;
        }

        const status = modalAction === 'approve' ? 'forwarded_to_principal' : modalAction === 'revert' ? 'reverted_to_student' : 'rejected_by_sfa';
        try {
            setActionLoading(true);
            const res = await http.post('/College/updateExternalCreditStatus', {
                credit_ids: [creditID],
                status: status,
                remarks: remarks,
            });
            if (res?.data?.status === true) {
                const successMessage =
                    status === 'forwarded_to_principal'
                        ? 'Data Forwarded to Principal Successfully'
                        : status === 'reverted_to_student'
                            ? 'Application Reverted Successfully'
                            : status === 'rejected_by_sfa' ? 'Application Rejected Successfully' : null;

                toast.success(successMessage);
                setStudents(prev =>
                    prev.map(s =>
                        s.credit_id === selectedCredit.credit_id ? { ...s, status } : s
                    )
                );
                setReload(!reload);
                closeModal();

            } else {
                toast.error(res?.data?.message || 'Status update failed');
            }
        } catch (err) {
            console.error('Error updating status:', err);
            toast.error('Something went wrong. Please try again.');
        } finally {
            setActionLoading(false);
        }
    };

    // const openViewModal = async (student) => {
    //     setShowViewModal(true);
    //     setViewData(null);
    //     setViewLoading(true);
    //     try {
    //         const res = await http.post('/College/getStudentCreditApplication', {
    //             account_id: student.accountid,
    //             credit_id: student.id,
    //         });
    //         if (res.data.status) {
    //             setViewData(res.data.data);
    //         } else {
    //             toast.error('Failed to load application details.');
    //             setShowViewModal(false);
    //         }
    //     } catch (err) {
    //         console.error('Error fetching application details:', err);
    //         toast.error('Something went wrong while loading details.');
    //         setShowViewModal(false);
    //     } finally {
    //         setViewLoading(false);
    //     }
    // };

    // const closeViewModal = () => {
    //     setShowViewModal(false);
    //     setViewData(null);
    // };

    // /**
    //  * Fetch PDF as blob using encryptedKey, then open in modal
    //  */
    // const openPdfModal = async (encryptedFile, fileName) => {
    //     setPdfLoading(true);

    //     try {
    //         const res = await http.get(
    //             `/College/fetchSecureExternalCreditPdf/${encodeURIComponent(encryptedFile)}`,
    //             { responseType: 'blob' }
    //         );

    //         const contentType = res.headers['content-type'];

    //         const blobUrl = URL.createObjectURL(
    //             new Blob([res.data], { type: contentType })
    //         );

    //         setPdfModal({
    //             show: true,
    //             url: blobUrl,
    //             name: fileName,
    //             type: contentType
    //         });

    //     } catch (err) {
    //         console.error('Error fetching file:', err);
    //         toast.error('Failed to load document. Please try again.');
    //     } finally {
    //         setPdfLoading(false);
    //     }
    // };

    // const closePdfModal = () => {
    //     if (pdfModal.url) URL.revokeObjectURL(pdfModal.url);
    //     setPdfModal({ show: false, url: '', name: '', type: '' }); // add type: ''
    // };

    const handleDisciplineChange = (option) => {
        if (!option) return;
        setSelectedDiscipline(option.value);
        setCoursetype(option.course_type);
    };

    const handleAdmissionYearChange = (selectedOption) => {
        setSelectedYear(selectedOption.value);
    };

    const customStyles = {
        menu: (p) => ({ ...p, maxHeight: '200px', overflowY: 'auto' }),
        menuList: (p) => ({ ...p, maxHeight: '200px', overflowY: 'auto', scrollbarWidth: 'thin' }),
    };


    const handleSearchInputChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const handleSort = (column) => {
        const newSortBy = {
            column,
            direction: sortBy.column === column && sortBy.direction === 'asc' ? 'desc' : 'asc',
        };
        setSortBy(newSortBy);
    };


    useEffect(() => {
        const filteredAndSortedData = [...students].filter(item => {
            const query = searchQuery.toLowerCase();

            return (
                String(item.prn ?? '').toLowerCase().includes(query) ||
                String(item.accountid ?? '').toLowerCase().includes(query) ||
                String(item.studentname ?? '').toLowerCase().includes(query) ||
                String(item.apaar_no ?? '').toLowerCase().includes(query) ||
                String(item.course_name ?? '').toLowerCase().includes(query) ||
                String(item.acquired_credits ?? '').toLowerCase().includes(query) ||
                String(item.application_status ?? '').toLowerCase().includes(query) ||
                String(item.application_status_label ?? '').toLowerCase().includes(query)

            );
        }).sort((a, b) => {
            if (sortBy.direction === 'asc') {
                return a[sortBy.column] > b[sortBy.column] ? 1 : -1;
            } else {
                return a[sortBy.column] < b[sortBy.column] ? 1 : -1;
            }
        });

        const itemsPerPage = 50;
        const startIndex = (currentPage - 1) * itemsPerPage;
        const paginatedData = filteredAndSortedData.slice(startIndex, startIndex + itemsPerPage);

        setfilteredAndSortedData(paginatedData);
        setTotalPages(Math.ceil(filteredAndSortedData.length / itemsPerPage));
        setTotal(filteredAndSortedData.length);

    }, [searchQuery, sortBy, students, currentPage]);

    const renderSortIcon = (columnName) => {
        if (sortBy.column === columnName) {
            return sortBy.direction === 'asc' ? <i className="fa fa-sort-up ml-1" aria-hidden="true"></i> : <i className="fa fa-sort-down ml-1" aria-hidden="true"></i>;
        }
        return <i className="fa fa-sort ml-1" aria-hidden="true"></i>; // Show disabled sort icon
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1);
        }
    };

    const handlePreviousPage = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    /* DATA TABLE END */
    const statusBadgeMap = {
        "Submitted by Student": "bg-primary",

        "Forwarded to Principal": "bg-info text-dark",
        "Forwarded to University": "bg-info text-dark",
        "Forwarded to BOS": "bg-warning text-dark",

        "BOS Approved": "bg-success",
        "Application Approved": "bg-success",

        "Rejected by SFA": "bg-danger",
        "Rejected by Principal": "bg-danger",
        "Rejected by University": "bg-danger",
        "Course Rejected": "bg-danger",
        "Application Reverted": "bg-warning text-dark"
    };
    
    return (
        <>
            <ToastContainer />
            <Template>
                <div className="adl-stl-page sfa-ext-credit">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="card">
                                    <div className="col-md-12">
                                        <div className="card-header">
                                            <div className="py-3 d-flex justify-content-between align-items-center">
                                                <h5>Student External Course Credit
</h5>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body">
                                        <div className="card-body pdg">
                                            <div className="table-responsive">
                                                <form className="form theme-form">
                                                    <div className="card-body custom-input">
                                                        <div className="col">
                                                            <div className="row m-b-20">
                                                                <div className="col-md-6">
                                                                    <label>Admission Year <span className="errorclr">*</span></label>
                                                                    <Select
                                                                        maxMenuHeight={200}
                                                                        menuPlacement="auto"
                                                                        id="admission_year"
                                                                        name="admission_year"
                                                                        className="form w-100"
                                                                        styles={customStyles}
                                                                        options={admissionYears}
                                                                        onChange={handleAdmissionYearChange}
                                                                    />
                                                                    {errors.admyear && <p className="text-danger">{errors.admyear}</p>}
                                                                </div>
                                                                {/* <div className="col-md-6">
                                                                    <label>Discipline <span className="errorclr">*</span></label>
                                                                    <Select
                                                                        maxMenuHeight={200}
                                                                        menuPlacement="auto"
                                                                        id="discipline_id"
                                                                        name="discipline_id"
                                                                        className="form"
                                                                        styles={disciplineStyles}
                                                                        onChange={handleDisciplineChange}
                                                                        options={flag ? [{ value: '0', label: 'No data found' }] : disciplines}
                                                                    />
                                                                    {errors.discipline_id && <p className="text-danger">{errors.discipline_id}</p>}
                                                                </div> */}


                                                            </div>
                                                        </div>
                                                        <div className='row'>
                                                            <div className=''>

                                                                {courseDiciplineNameData && courseDiciplineNameData.length > 0 ? (
                                                                    <div className="txt-aln sfa-dis-headg">
                                                                        <h5> Department/Discipline:  {courseDiciplineNameData}{collegeDiciplineSchemeID === 4 ? '(B.Voc)' : ''} {collegeDiciplineTypeData == 1 ? '- Single Faculty Course' : ''} </h5>
                                                                    </div>
                                                                ) : (null

                                                                )}
                                                            </div>

                                                            <div className='col-md-6 wdt' >
                                                                <p>
                                                                    Showing {(currentPage - 1) * 50 + 1}{''}-
                                                                    {Math.min((currentPage - 1) * 50 + 50, total_count)} of {total_count} entries
                                                                </p>
                                                            </div>
                                                            <div className='col-md-6 wdt' align='right'>
                                                                <input
                                                                    type="text"
                                                                    value={searchQuery}
                                                                    onChange={handleSearchInputChange}
                                                                    placeholder="Search..."
                                                                    className='form-control'
                                                                /></div></div>
                                                        <div class="table-container sfa-ext-credit" style={{ overflowX: 'auto' }}>


                                                            {/* <table className="display dataTable table-striped table-bordered" ref={tableRef} style={{ width: '100%' }}> */}
                                                            <table className="display dataTable table-striped table-bordered ex-v-table " ref={tableRef}>

                                                                <thead>
                                                                    <tr className="bg-primary">
                                                                        <th onClick={() => handleSort('PRN')} width="8%" style={{ textAlign: "left", verticalAlign: "middle" }}>Sl No.&nbsp; {renderSortIcon('PRN')} </th>
                                                                        <th onClick={() => handleSort('PRN')} width="15%" style={{ textAlign: "left", verticalAlign: "middle" }}>PRN/Student Name&nbsp; {renderSortIcon('PRN')} </th>

                                                                        <th onClick={() => handleSort('')}>Course Name &nbsp; {renderSortIcon('course_name')}</th>
                                                                        <th onClick={() => handleSort('course_discipline')} width="">Course Discipline &nbsp; {renderSortIcon('course_discipline')}</th>

                                                                        <th onClick={() => handleSort('acquired_credits')} width="10%">Course Credit &nbsp; {renderSortIcon('acquired_credits')}</th>
                                                                        <th onClick={() => handleSort('application_status_label')} width="20%">Appication Status &nbsp; {renderSortIcon('application_status_label')}</th>
                                                                        <th width="20%">Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>

                                                                    {filteredAndSortedData.length > 0 ? (
                                                                        filteredAndSortedData.map((student, index) => {
                                                                            console.log(student.id)
                                                                            const isStudentSubmitted =
                                                                                student.application_status === 'forwarded_to_sfa';

                                                                            return (
                                                                                <tr key={student.accountid}>
                                                                                    <td className='text-center'>{index + 1}</td>
                                                                                    <td>
                                                                                        <div className="d-flex flex-column text-center">
                                                                                            <span className="fw-semibold">{student.prn}</span>
                                                                                            <span className="text-muted small">{student.studentname}</span>
                                                                                        </div>
                                                                                    </td>
                                                                                    <td className=''>{student.course_name}</td>
                                                                                    <td className=''>{student.course_discipline}</td>
                                                                                    <td className='text-center'>{student.acquired_credits}</td>
                                                                                    <td className='text-center'>
                                                                                       

                                                                                        <span
                                                                                            className={`badge ${statusBadgeMap[student.application_status_label] ||
                                                                                                "bg-warning text-dark"
                                                                                                }`}
                                                                                        >
                                                                                            {student.application_status_label || "Pending"}
                                                                                        </span>

                                                                                    </td>
                                                                                    {/* <td className=''>
                                                                                        <div className="d-flex flex-row justify-content-center align-items-center">
                                                                                            <button
                                                                                                type="button"
                                                                                                className="btn btn-info btn-sm mb-2 w-75"
                                                                                                onClick={() => openViewModal(student)}
                                                                                                title="View"
                                                                                            >
                                                                                                <i className="fa fa-eye"></i>
                                                                                            </button>
                                                                                            {/* SHOW ONLY IF isForwarded === true */}
                                                                                    {/* Forward & Reject ONLY when forwarded_to_sfa */}
                                                                                    {/* {isStudentSubmitted && (
                                                                                                <>
                                                                                                    <button
                                                                                                        type="button"
                                                                                                        className="btn btn-success btn-sm mb-2 w-75"
                                                                                                        onClick={() =>
                                                                                                            openActionModal(student, student.id, 'approve')
                                                                                                        }
                                                                                                        title="Forward to Principal"
                                                                                                    >
                                                                                                        <i className="fa fa-check mr-1"></i>                                                                                                     </button>

                                                                                                    <button
                                                                                                        type="button"
                                                                                                        className="btn btn-danger btn-sm w-75"
                                                                                                        onClick={() =>
                                                                                                            openActionModal(student, student.id, 'reject')
                                                                                                        }
                                                                                                        title="Reject to Candidate"
                                                                                                    >
                                                                                                        <i className="fa fa-times mr-1"></i> 
                                                                                                    </button>
                                                                                                </>
                                                                                            )}
                                                                                        </div>
                                                                                    </td> */}

                                                                                    <td style={{ textAlign: "center", verticalAlign: "middle" }}>

                                                                                        <div className="college-action-btn-group">

                                                                                            <ActionBtn
                                                                                                onClick={() => openViewModal(student)}
                                                                                                title="View Application"
                                                                                                borderColor="#0dcaf0"
                                                                                                icon="bi bi-eye-fill"
                                                                                            />

                                                                                            {isStudentSubmitted && (
                                                                                                <>

                                                                                                    <ActionBtn

                                                                                                        onClick={() =>
                                                                                                            openActionModal(student, student.id, 'approve')
                                                                                                        }
                                                                                                        title="Forward to Principal"
                                                                                                        borderColor="#198754"
                                                                                                        icon="bi bi-send-fill"
                                                                                                    />

                                                                                                    <ActionBtn
                                                                                                        onClick={() =>
                                                                                                            openActionModal(student, student.id, 'revert')
                                                                                                        }
                                                                                                        title="Revert Application"
                                                                                                        borderColor="#FFAA05"
                                                                                                        icon="fa fa-undo"

                                                                                                    />

                                                                                                    <ActionBtn
                                                                                                        onClick={() =>
                                                                                                            openActionModal(student, student.id, 'reject')
                                                                                                        }
                                                                                                        title="Reject Application"
                                                                                                        borderColor="#dc3545"
                                                                                                        icon="bi bi-x-lg"
                                                                                                    />

                                                                                                </>
                                                                                            )}
                                                                                        </div>
                                                                                    </td>
                                                                                </tr>
                                                                            );
                                                                        })
                                                                    ) : (
                                                                        <tr>
                                                                            <td colSpan="7" className="text-center">No students found</td>
                                                                        </tr>
                                                                    )}
                                                                </tbody>
                                                            </table>
                                                        </div>

                                                        {totalPages > 1 && (
                                                            <nav aria-label="..." style={{ cursor: "pointer" }}>
                                                                <ul className="pagination justify-content-center">
                                                                    <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                                        <span className="page-link pgn-clr" onClick={handlePreviousPage}><i class="bi bi-arrow-left-circle-fill"></i></span>
                                                                    </li>
                                                                    <li className={`page-item`}>
                                                                        <span className="page-link pgn-clr" onClick={() => handlePageChange(1)}>1</span>
                                                                    </li>
                                                                    {currentPage > 4 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}
                                                                    {[...Array(totalPages - 1).keys()].slice(currentPage > 4 ? currentPage - 3 : 1, currentPage + 2).map((pageNumber) => (
                                                                        <li key={pageNumber} className={`page-item ${pageNumber + 1 === currentPage ? 'act-clr' : ''}`}>
                                                                            <span className="page-link pgn-clr" onClick={() => handlePageChange(pageNumber + 1)}>{pageNumber + 1}</span>
                                                                        </li>
                                                                    ))}
                                                                    {currentPage < totalPages - 3 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}

                                                                    <li className={`page-item`}>
                                                                        <span className="page-link pgn-clr" onClick={() => handlePageChange(totalPages)}>{totalPages}</span>
                                                                    </li>

                                                                    <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                                        <span className="page-link pgn-clr" onClick={handleNextPage}><i class="bi bi-arrow-right-circle-fill"></i></span>
                                                                    </li>
                                                                </ul>
                                                            </nav>
                                                        )}
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Template>

            {/* ── Confirmation Modal ── */}
            {showModal && (
                <div
                    className="modal fade show"
                    style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }}
                    tabIndex="-1"
                    role="dialog"
                >
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className={`modal-header ${modalAction === 'approve' ? 'bg-success' : modalAction === 'revert' ? 'bg-warning' : 'bg-danger'} text-white`}>
                                <h5 className="modal-title">
                                    {modalAction === 'approve'
                                        ? <><i className="fa fa-check-circle mr-2"></i>Forward Application</>
                                        : modalAction === 'revert'
                                            ? <><i className="fa fa-undo mr-2"></i>Revert Application</>
                                            : <><i className="fa fa-times-circle mr-2"></i>Reject Application</>}
                                </h5>
                                <button type="button" className="btn-close text-white" onClick={closeModal} disabled={actionLoading}>

                                </button>
                            </div>
                            <div className="modal-body">
                                <p className="mb-2">
                                    {modalAction === 'approve'
                                        ? 'Are you sure you want to forward this application to Principal?'
                                        : modalAction === 'revert'
                                            ? 'Are you sure you want to revert this application to the candidate?'
                                            : 'Are you sure you want to reject this application to the candidate?'}
                                </p>
                                {selectedCredit && (
                                    <div className="alert alert-light border mb-3">
                                        <strong>Student:</strong> {selectedCredit.studentname}<br />
                                        <strong>PRN:</strong> {selectedCredit.prn}<br />
                                        <strong>Course:</strong> {selectedCredit.course_name}
                                    </div>
                                )}
                                {modalAction !== 'approve' && (
                                    <div className="form-group mb-0">
                                        <label>Remarks <span className="text-danger">*</span></label>
                                        <textarea
                                            className="form-control"
                                            rows="3"
                                            maxLength={500}
                                            placeholder="Enter remarks..."
                                            value={remarks}
                                            onChange={(e) => setRemarks(e.target.value)}
                                        />
                                    </div>
                                )}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={closeModal} disabled={actionLoading}>Cancel</button>
                                <button
                                    type="button"
                                    className={`btn ${modalAction === 'approve' ? 'btn-success' : modalAction === 'revert' ? 'btn-warning' : 'btn-danger'}`}
                                    onClick={handleConfirmAction}
                                    disabled={actionLoading}
                                >
                                    {actionLoading
                                        ? <><span className="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span> Processing...</>
                                        : modalAction === 'approve' ? 'Confirm Forward' : modalAction === 'revert' ? 'Confirm Revert' : 'Confirm Reject'}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* ── View Application Modal (new style) ── */}
            <ViewApplicationModal
                showViewModal={showViewModal}
                closeViewModal={closeViewModal}
                viewData={viewData}
                viewLoading={viewLoading}
                pdfLoading={pdfLoading}
                pdfModal={pdfModal}
                openPdfModal={openPdfModal}
                closePdfModal={closePdfModal}
            />
            <PDFModal
                isOpen={pdfModal.show}
                onClose={closePdfModal}
                pdfUrl={pdfModal.url}
                fileName={pdfModal.name}
                fileType={pdfModal.type}   // <-- add this
            />
        </>
    );
}